import { IsBoolean } from "class-validator";

export class TemplateHomeMenuFieldDto {
  @IsBoolean()
  visible!: boolean;
}
